module.exports = __webpack_public_path__ + "img/d365b41.png";